<template>
	<div id="changePasswordModalComponent">
		<button :class="_class" data-toggle="modal" data-target=".change-password-modal" ref="btnShowChangePasswordModalComponent"
			@click="btnShowChangePasswordModalComponent"
			v-show="enableComponent == true">
				<i class="fas fa-lock"></i>
				{{title}}
			</button>

		<div class="modal fade change-password-modal" tabindex="-1" role="dialog" aria-labelledby="myLargeModalLabel" aria-hidden="true" data-keyboard="false" data-backdrop="static">
			<div class="modal-dialog modal-sm">
				<div class="modal-content">
					<div class="modal-header">
						<h5 class="modal-title">Cambio de contraseña</h5>
						<button type="button" class="close" data-dismiss="modal" aria-label="Close">
							<span aria-hidden="true">&times;</span>
						</button>
					</div>
					<div class="modal-body text-left">
						<div class="alert alert-warning text-center" role="alert" v-if="message != ''">
							{{message}}
						</div>
						<div class="form-group">
							<label for="currentPasswordInput">Contraseña Actual</label>
							<input type="password" class="form-control form-control-sm" id="currentPasswordInput" v-model="currentPassword">
						</div>
						<div class="form-group">
							<label for="newPasswordInput">Nueva Contraseña</label>
							<input type="password" class="form-control form-control-sm" id="newPasswordInput" v-model="newPassword">
						</div>
						<div class="form-group">
							<label for="newRepetPasswordInput">Repita la Nueva Contraseña</label>
							<input type="password" class="form-control form-control-sm" id="newRepetPasswordInput" v-model="newRepetPassword">
						</div>
  					</div>
					<div class="modal-footer">
						<button type="button" class="btn btn-sm btn-secondary" data-dismiss="modal" ref="btnCloseChangePasswordModalComponent">Cerrar</button>
						<button type="button" class="btn btn-sm btn-danger" :disabled="btnSaveDisabled" @click="changePasswordLocal">{{(this.changingPassword == false) ? 'Cambiar contaseña' : 'Cambiando contaseña...'}}</button>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import mixin from '@/mixins'
	import errors from '@/mixins/errors.js'
	import axiosAction from '@/mixins/axiosAction.js'
	import users from '@/mixins/users'
	
	export default {
		name: 'ChangePasswordModalComponent',
		mixins: [axiosAction, errors, mixin, users],
		props:['message', 'enableComponent', 'title', '_class'],
		data () {
			return {
				currentPassword: '',
				newPassword: '',
				newRepetPassword: '',
				passwordMinLength: 8,
				changingPassword: false
			}
		},
		computed: {
			btnSaveDisabled() {
				if(this.currentPassword.trim().length == 0)
					return true
				if(this.newPassword.trim().length < this.passwordMinLength)
					return true
				if(this.newPassword.trim() != this.newRepetPassword.trim())
					return true
				if(this.currentPassword.trim() == this.newRepetPassword.trim())
					return true
				if(this.changingPassword)
					return true
				return false
			}
		},
		methods: {
			initComponentLocal() {
				this.resetComponentLocal()
			},
			btnShowChangePasswordModalComponent() {
				this.resetComponentLocal()
			},
			resetComponentLocal() {
				this.currentPassword = ''
				this.newPassword = ''
				this.newRepetPassword = ''
			},
			changePasswordLocal() {
				if(!this.btnSaveDisabled) {
					this.changingPassword = true
					this.changePassword(this.currentPassword.trim(), this.newRepetPassword.trim())
				}
			},
			changePasswordResultLocal(response) {
				this.changingPassword = false
				if(response.data.success) {
					this.$snotify.success(response.data.message, response.data.data)
					this.$emit('actionPasswordChanged', response)
				} else {
					this.$snotify.error(response.data.data.message, response.data.data.error)
				}
			}
		}
	}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
</style>
